import { IonSpinner } from '@ionic/react';
import React from 'react';

type Props = { color?: string };

export const Spinner: React.FC<Props> = ({ color }) => (
  <IonSpinner color={color} name="crescent" />
);
